import type { FabricObject } from 'fabric';

/**
 * Restyle a parsed glyph path without moving its letters.
 *
 * fabric 6 anchors an object parsed from SVG at its top-left corner, and that
 * corner sits half a stroke outside the outline. Changing `strokeWidth` after
 * parsing therefore slides the glyphs by Δstroke/2. The name/number outline is
 * a stroked copy UNDER a fill-only copy, so the two copies drifted apart by
 * half the outline: no outline on the top/left edges, a double one on the
 * bottom/right (order 28372). Keeping the centre fixed makes the copies
 * coincide, as the builder's single stroked path does. fabric 7 already
 * anchors at the centre; there this is a no-op.
 */
export function restyleKeepingCentre(obj: FabricObject, props: Record<string, unknown>): void {
  const centre = obj.getCenterPoint();
  obj.set(props);
  obj.setPositionByOrigin(centre, 'center', 'center');
}
